/**
 * // TODO: перевести на ts
 * @see https://leveltravel.atlassian.net/browse/LT-24298
 */
import React from 'react';
import { uniq, isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import { HotelCard, HotelCardSmall } from '@lt/components';

import { objToQueryString } from 'src/utils/uriUtils';
import Wishlist from 'src/components/Wishlist';
import styled from 'styled-components';
import {
  getCheapestDate,
  getHotelExtraParams,
  getSuggestedTour,
} from '../../utils';

class HotelRenderer extends React.PureComponent {
  componentWillUnmount() {
    if (this.hoverTimeout) {
      clearTimeout(this.hoverTimeout);
    }
  }

  onHover = () => {
    const { onHover, hotelInfo, index, isViewed } = this.props;
    if (!onHover) {
      return;
    }

    const {
      hotel: { id, long, lat },
    } = hotelInfo;

    // Fortuna doesn't have coordinates. It is therefore not shown on map
    if (long && lat) {
      const activeHotelData = {
        index,
        id,
        coordinates: [long, lat],
        visited: isViewed,
      };

      this.hoverTimeout = setTimeout(() => onHover(activeHotelData), 600);
    }
  };

  onMouseLeave = () => this.hoverTimeout && clearTimeout(this.hoverTimeout);

  getLocation() {
    const { destinationTitle, hotelInfo } = this.props;
    const { region_name, city } = hotelInfo.hotel;

    const normalizeCity = city.name_ru || city;
    const location = uniq([normalizeCity, region_name, destinationTitle])
      .filter(Boolean)
      .join(', ');
    return location;
  }

  buildSuggestedHotelURL = ({
    packageInfo,
    offerFilters,
    requestId,
    normalizeLink,
    date,
    price,
    nightsCount,
    searchType,
  }) => {
    const dates = {};
    dates[date] = price; // пиздец

    const queryParams = getHotelExtraParams(
      {
        ...packageInfo,
        dates,
        min_price_nights: nightsCount,
      },
      offerFilters,
    );
    const query = objToQueryString({
      request_id: requestId,
      search_type: searchType,
      ...queryParams,
    });
    return `${normalizeLink}${query ? `?${query}` : ''}`;
  };

  buildHotelURL = ({
    packageInfo,
    offerFilters,
    requestId,
    normalizeLink,
    searchType,
  }) => {
    const queryParams = getHotelExtraParams(packageInfo, offerFilters);

    const query = objToQueryString({
      request_id: requestId,
      search_type: searchType,
      ...queryParams,
    });
    return `${normalizeLink}${query ? `?${query}` : ''}`;
  };

  loadAll() {
    const { hotelId, getImages } = this.props;
    getImages(hotelId);
  }

  render() {
    const {
      hotelInfo,
      isSmallCard,
      touristsCount,
      isMobile,
      isWebview,
      isViewed,
      offerFilters,
      requestId,
      imagesList,
      FooterComponent,
      className,
      hotelId,
      hotelClicked,
      isHotelOnly,
      isFlexDates,
      activateCashbackForPartner,
      customCashbackIconURL,
      customCashbackText,
      customCashbackTooltipText,
      wishlist,
      currencyCode,
      onChangeFilter,
      isPreloadable,
      isMapCard,
      resetPopupDataHandler,
      onClosePopup,
    } = this.props;

    const {
      hotel,
      bonus_count,
      cashback_identifier,
      extras,
      surcharge,
      min_price_nights,
      dates,
      min_price: price,
      availability,
      cancellation_policy: cancellationPolicy,
      labels,
      penalized_filters,
      adjacent_tours = [],
    } = hotelInfo;

    const { lt_extras: ltExtras } = hotel;

    const packageInfo = {
      touristsCount,
      price,
      min_price_nights,
      cancellationPolicy,
      dates,
      surcharge,
    };

    const normalizeLink = hotel.link || hotel.public_url;
    const searchType = isHotelOnly ? 'hotel' : 'package';

    const getBonusCount = () => {
      if (!activateCashbackForPartner) return null;

      return bonus_count;
    };

    const href = this.buildHotelURL({
      packageInfo,
      offerFilters,
      requestId,
      normalizeLink,
      searchType,
    });

    const suggestedDates = adjacent_tours.map((tour) => ({
      ...getSuggestedTour(tour),
      currencyCode,
      href: this.buildSuggestedHotelURL({
        packageInfo,
        offerFilters,
        requestId,
        normalizeLink,
        date: tour.start_date,
        price: tour.price,
        nightsCount: tour.duration,
        searchType,
      }),
    }));

    const closeHotelPopup = () => {
      resetPopupDataHandler();
      onClosePopup?.();
    };

    const props = {
      className,
      customCashbackIconURL,
      customCashbackText,
      customCashbackTooltipText,
      wishlist,
      FooterComponent,
      isSmallCard,
      isMobile,
      openInCurrentTab: isWebview,
      hotel,
      extras,
      hasLtExtras: !isEmpty(ltExtras),
      isViewed,
      images: {
        list: imagesList,
        count: imagesList.length,
        onSlideChange: () => this.loadAll(),
      },
      hotelHref: href,
      location: this.getLocation(),
      price,
      currencyCode,
      nights: min_price_nights,
      touristsCount,
      surcharge,
      date: getCheapestDate(dates),
      cancellationPolicy,
      labels,
      penalized_filters,
      onChangeFilter,
      availability,
      suggestedDates,
      bonus_count: getBonusCount(),
      cashbackIdentifier: cashback_identifier,
      dataLayer: {
        hotelClicked: penalized_filters ? hotelClicked : undefined,
      },
      isFlexDates,
      isPreloadable,
      isMapCard,
      closeHotelPopup: isMapCard ? closeHotelPopup : undefined,
    };

    const renderNeededCard = () => {
      if (!isMobile && isMapCard)
        return <HotelCard {...props} isHotelOnly={isHotelOnly} />;
      if (!isMobile && !isMapCard)
        return isSmallCard ? (
          <HotelCardSmall {...props} isHotelOnly={isHotelOnly} />
        ) : (
          <HotelCard {...props} isHotelOnly={isHotelOnly} />
        );
      return <HotelCardSmall {...props} isMobile isHotelOnly={isHotelOnly} />;
    };

    return (
      <StyledRelativeWrapper
        onMouseEnter={this.onHover}
        onMouseLeave={this.onMouseLeave}
      >
        {renderNeededCard()}
        <StyledWishlist
          type="hotel"
          wishlistIdentifier={hotelId}
          isWhiteHeart={isSmallCard || (isMobile && isMapCard)}
          isHotelCardFromMap={isMapCard}
          $labels={Boolean(
            !isMapCard && labels?.find((label) => label.context?.search === 1),
          )}
        />
      </StyledRelativeWrapper>
    );
  }
}

const StyledRelativeWrapper = styled.div`
  position: relative;
`;
const StyledWishlist = styled(Wishlist)`
  top: ${({ $labels }) => ($labels ? `32px` : '8px')};
`;

HotelRenderer.propTypes = {
  hotelInfo: PropTypes.shape({}).isRequired,
  country: PropTypes.string.isRequired,
  destinationTitle: PropTypes.string.isRequired,
  touristsCount: PropTypes.number.isRequired,
  onHover: PropTypes.func,
  onChangeFilter: PropTypes.func,
  isSmallCard: PropTypes.bool,
  cardFooter: PropTypes.element,
  isMobile: PropTypes.bool,
  offerFilters: PropTypes.shape({
    instantConfirm: PropTypes.bool.isRequired,
    operators: PropTypes.string.isRequired,
  }).isRequired,
  isFlexDates: PropTypes.bool.isRequired,
  isMapCard: PropTypes.bool,
  onClosePopup: PropTypes.func,
};

HotelRenderer.defaultProps = {
  onHover: null,
  isSmallCard: false,
  cardFooter: null,
  isMobile: false,
};

export default HotelRenderer;
